if(!customElements.get('collections-image-slider')) {
  customElements.define(
    'collections-image-slider',
    class CollectionsImageSlider extends HTMLElement {
      sliderEl = null;
      sliderInstance = null;

      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        if(!this.sliderEl) {
          return console.error('An error ocurred while trying to initialize Hero Slider. No slider element was found.')
        }

        const count = parseInt(this.getAttribute('data-item-count')) || 5;
        const gap = count < 5 ? 16 + (5 - count) * 8 : 16;

        this.sliderInstance = new Swiper(this.sliderEl, {
          slidesPerView: Math.min(1.4, count),
          spaceBetween: 16,
          centerInsufficientSlides: true,
          navigation: {
            prevEl: '.collections-image-slider-button.slider-button.prev',
            nextEl: '.collections-image-slider-button.slider-button.next',
          },
          pagination: {
            el: '.collections-image-slider-pagination',
            type: 'bullets',
            clickable: true
          },
          breakpoints: {
            450: {
              slidesPerView: Math.min(2.5, count)
            },
            768: {
              slidesPerView: Math.min(3.4, count),
              spaceBetween: gap
            },
            1024: {
              slidesPerView: Math.min(3.4, count),
              spaceBetween: gap
            },
            1280: {
              slidesPerView: Math.min(5, count),
              spaceBetween: gap
            }
          },
        });
      }
    }
  );
}
